<template>
    <div class="warp">
      <!-- 面包屑 -->
      <breadcrumb :back="true" :crubList="[{name:'债权融资管理'},{name:'债权融资需求列表',goback:true},{name:'债权融资需求明细'}]" :title="'债权融资需求明细'" />
      <!-- 选项卡 -->
      
      <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
        <el-tab-pane label="债权需求详情" name="1"></el-tab-pane>
        <el-tab-pane label="推荐产品" name="2"></el-tab-pane>
      </el-tabs>
      <!-- 主体 -->
      <!-- 产品详情 -->
      <div class="box super_boxs" v-show="tab==='1'">
        <el-card class="basic box_card" header="" shadow="never">
          <div class="basisTitle">债权融资需求详情：</div>
          <el-row>
            <el-col :span="8">
              <div class="child">
          <div class="name">银行名称：</div>
          <div class="content">{{basicInfo.bankName}}</div>
        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
          <div class="name">企业全称：</div>
          <div class="content">{{basicInfo.companyName}}</div>
        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
          <div class="name">行业：</div>
          <div class="content">{{basicInfo.industryStr}}</div>
        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
          <div class="name">拟贷款金额（万元）：</div>
          <div class="content">{{basicInfo.proLoanAmount}}</div>
        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
          <div class="name">企业员工数：</div>
          <div class="content">{{basicInfo.employNum}}</div>
        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
          <div class="name">上年度营收：</div>
          <div class="content">{{basicInfo.lastYearBusinessIncomeStr}}</div>
        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
          <div class="name">上年度纳税：</div>
          <div class="content">{{basicInfo.lastYearPayTaxesStr}}</div>
        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
          <div class="name">联系人：</div>
          <div class="content">{{basicInfo.contact||"--"}}</div>
        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
          <div class="name">联系电话：</div>
          <div class="content">{{basicInfo.contactPhone||"--"}}</div>
        </div>
            </el-col>
            <el-col :span="8">
              <div class="child">
          <div class="name">联系邮箱：</div>
          <div class="content">{{basicInfo.contactEmail||"--"}}</div>
        </div>
            </el-col>
            <el-col :span="8">
              <div class="attachment">
          <div class="name">附件：</div>
          <ul class="content">
            <li v-for="(item,index) in basicInfo.fileList" :key="index">
              <span>{{item.fileName}}</span>
              <i class="el-icon-download" @click="downLoad(item)"></i>
            </li>
          </ul>
        </div>
            </el-col>
            
          </el-row>
        </el-card>
        <el-card class="basic box_card mt16" header="" shadow="never">
                <div class="basisTitle">开户行受理信息：</div>
                <el-row>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">受理状态：</div>
          <div class="content">{{basicInfo.acceptStatusValue||"--"}}</div>
        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">放款金额（万元）：</div>
          <div class="content">{{basicInfo.acceptLoanAmount||"--"}}</div>
        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">说明：</div>
          <div class="content">{{basicInfo.acceptInstructions||"--"}}</div>
        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">更新时间：</div>
          <div class="content">{{basicInfo.acceptDate||"--"}}</div>
        </div>
                  </el-col>
                  <el-col :span="8"></el-col>
                  <el-col :span="8"></el-col>
                  <el-col :span="8"></el-col>
                </el-row>

        </el-card>
        <el-card class="basic box_card mt16" header="" shadow="never">
                <div class="basisTitle">需求状态：</div>
                <el-row>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">需求状态：</div>
          <div class="content">{{basicInfo.demandStatusValue||"--"}}</div>
        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">放款金额（万元）：</div>
          <div class="content">{{basicInfo.demandLoanAmount||"--"}}</div>
        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">贷款银行：</div>
          <div class="content">{{basicInfo.loanBank||"--"}}</div>
        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">说明：</div>
          <div class="content">{{basicInfo.demandInstructions||"--"}}</div>
        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">更新时间：</div>
          <div class="content">{{basicInfo.demandDate||"--"}}</div>
        </div>
                  </el-col>
                  
                </el-row>

        </el-card>
        <el-card class="basic box_card mt16" header="" shadow="never">
                <div class="basisTitle">其它信息：</div>
                <el-row>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">发布账号：</div>
          <div class="content">{{basicInfo.releaseAccount||"--"}}</div>
        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">发布时间：</div>
          <div class="content">{{basicInfo.createTime||"--"}}</div>
        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">更新账号：</div>
          <div class="content">{{basicInfo.modifyAccount||"--"}}</div>
        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
          <div class="name">更新时间：</div>
          <div class="content">{{basicInfo.updateTime||"--"}}</div>
        </div>
                  </el-col>
                </el-row>
        </el-card>
      </div>
      <!-- 客户申请表格 -->
      <el-table
        v-show="tab==='2'"
        :data="tableData"
        @sort-change="sortChange"
        ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
        style="width: 100%"
      >
        <el-table-column prop="id" show-overflow-tooltip  label="债权产品ID"></el-table-column>
        <el-table-column prop="debtProductName" show-overflow-tooltip  label="产品名称"></el-table-column>
        <el-table-column prop="loanTypeValue" show-overflow-tooltip  label="贷款类型"></el-table-column>
        <el-table-column prop="bankName" show-overflow-tooltip  label="银行名称"></el-table-column>
        <el-table-column
          prop="releaseAccount"
          show-overflow-tooltip
          
          sortable="custom"
          label="发布账号"
        ></el-table-column>
        <el-table-column label="操作"  width="200">
          <template slot-scope="scope">
            <el-button size="small" type="primary" class="super" plain @click="check(scope.row)">查看</el-button>
            <el-button size="small" type="primary" class="super" plain @click="cancelRe(scope.row)">取消推荐</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination" v-show="tab==='2'" ref='pagination'>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="sendInfoOne.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        ></el-pagination>
      </div>
      <!-- 弹出成模块 -->
      <!-- 查看明细 -->
      <el-dialog
        title="债权产品信息"
        :visible.sync="dialogInfo"
        :close-on-click-modal="false"
        width="50%"
        custom-class="super_dialog"
      >
        <div class="basic">
          <div class="boxChild">
            <div class="basisTitle">债权产品信息</div>
            <div class="child">
              <div class="name">银行名称：</div>
              <div class="content">{{checkDetails.bankName}}</div>
            </div>
            <div class="child">
              <div class="name">产品名称：</div>
              <div class="content">{{checkDetails.debtProductName}}</div>
            </div>
            <div class="child">
              <div class="name">贷款类型：</div>
              <div class="content">{{checkDetails.loanTypeValue}}</div>
            </div>
            <div class="child">
              <div class="name">最高额度：</div>
              <div class="content">{{checkDetails.maxAmount}}</div>
            </div>
            <div class="child">
              <div class="name">最低额度：</div>
              <div class="content">{{checkDetails.minAmount}}</div>
            </div>
            <div class="child">
              <div class="name">贷款期限：</div>
              <div class="content">{{checkDetails.loanTerm}}</div>
            </div>
            <div class="child">
              <div class="name">担保方式：</div>
              <ol>
                <li
                  class="content"
                  v-for="(item,index) in checkDetails.guaranteeWay"
                  :key="index"
                >{{item.value}}</li>
              </ol>
            </div>
            <div class="child">
              <div class="name">年利率：</div>
              <div class="content">{{checkDetails.yearInterest}}</div>
            </div>
            <div class="child">
              <div class="name">产品介绍：</div>
              <div class="content super_p" v-html="checkDetails.productIntro"></div>
            </div>
            <div class="child">
              <div class="name">贷款须知：</div>
              <ul>
                <li
                  class="content"
                  v-for="(item,index) in checkDetails.loanKnown"
                  :key="index"
                >{{item.sort}}. {{item.content}}</li>
              </ul>
            </div>
            <div class="attachment">
              <div class="name">附件：</div>
              <ul class="content">
                <li v-for="(item,index) in checkDetails.fileList" :key="index">
                  <span>{{item.fileName}}</span>
                  <i class="el-icon-download" @click="downLoad(item)"></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import timeMixins from "@/mixins/timeFormat";
import breadcrumb from "../../components/breadcrumb";
import {onDownload} from "@/utils/common";
export default {
  mixins: [timeMixins],
  components: {
    breadcrumb
  },
  data() {
    return {
      bHeight: void 0,
      tab: '1', //选项卡
      sendInfoOne: {
        currentPage: 1, //当前页
        pageSize: 10, //页条数
        myDeptId: "", //申请id
        property: null, //排序字段
        direction: null //排序方式
      }, //检索提交数据
      tableData: [], //表格数据
      currentPage: 1, //当前页
      dialogInfo: false, //查看明细弹出层
      statusList: [],
      checkDetails: {
        applicant: "",
        contactPhone: "",
        applyCompany: "",
        applyRemark: "",
        fileList: [],
        createTime: "",
        rateValue: "",
        amount: "",
        checkExplanation: "",
        updateTime: ""
      },
      basicInfo: {
        bankName: "", //银行名
        companyName: "", //产品名称
        industryValue: "", //贷款类型
        proLoanAmount: "", //最高额度
        employNum: "", //最低额度
        operateIncomePreYear: "", //贷款期限
        profitsPreYear: "", //产品名称
        contact: "", //年利率
        contactPhone: "", //贷款须知
        contactEmail: "", //贷款须知
        fileList: [], //附件：
        acceptStatusValue: "", //发布账号：
        acceptLoanAmount: "", //发布时间：
        acceptInstructions: "", //更新账号：
        acceptDate: "", //更新时间：
        demandStatusValue: "", //更新时间：
        demandLoanAmount: "", //更新时间：
        loanBank: "", //更新时间：
        demandInstructions: "", //更新时间：
        demandDate: "", //更新时间：
        releaseAccount: "", //更新时间：
        createTime: "", //更新时间：
        modifyAccount: "", //更新时间：
        updateTime: "" //更新时间：
      },
      totalSize: null,
      checkDetails: {
        bankName: "", //账号
        debtProductName: "", //产品名称
        loanTypeValue: "", //贷款类型
        maxAmount: "", //最高额度
        minAmount: "", //最低额度
        loanTerm: "", //贷款期限
        guaranteeWay: [], //担保方式
        loanKnown: [],
        fileList: [], //附件列表
        yearInterest: "", //年利率
        productIntro: "" //产品介绍
      }
    };
  },
  methods: {
    download({fileName,filePath}){
      const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
    },
    doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
    //  取消推荐
    cancelRe(row) {
      this.$confirm("确认取消？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axiosc
            .put(
              "backstage/myDeptNeeds/cancel/" +
                this.sendInfoOne.myDeptId +
                "/" +
                row.id
            )
            .then(res => {
              if (res.code == 200) {
                this.getData();
                this.$message({
                  type: "success",
                  message: "取消推荐成功!"
                });
              } else {
                this.$alert(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    // 切换选项啦
    changeTab: function(tab) {
      const that = this
      that.tab = tab.name;
      that.getData();
      if(tab.name === '2'){
              setTimeout(() => {
                that.$nextTick(() => {
                  let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
              }, 200);
              
            }
    },
    //检索事件
    retrieval: function() {},
    //表格排序事件
    sortChange: function({ column, prop, order }) {
      if (order == "ascending") {
        order = "asc";
      } else {
        order = "desc";
      }
      this.sendInfoOne.property = prop;
      this.sendInfoOne.direction = order;
      this.getData();
    },
    getData() {
      if (this.tab == 1) {
        this.$axiosc
          .get("backstage/myDeptNeeds/" + this.sendInfoOne.myDeptId)
          .then(res => {
            if (res.code == 200) {
              this.basicInfo = res.data;
            }
          });
      } else {
        this.$axiosc
          .get(
            "backstage/myDeptNeeds/debt/financing/" + this.sendInfoOne.myDeptId,
            {
              params: this.sendInfoOne
            }
          )
          .then(res => {
            if (res.code == 200) {
              this.tableData = res.data.content;
              this.totalSize = res.data.totalElements;
            }
          });
      }
    },
    //查看明细
    check: function(row) {
      this.$axiosc
        .get("backstage/debt/financing/details/" + row.id)
        .then(res => {
          this.checkDetails = res.data;
          this.dialogInfo = true;
        });
    },
    //分页功能模块
    //切换每页显示条数
    handleSizeChange(val) {
      this.sendInfoOne.pageSize = val;
      this.getData();
    },
    //切换页码
    handleCurrentChange(val) {
      this.sendInfoOne.currentPage = val;
      this.getData();
    },
    //获取字典
    getDic: function() {
      this.$axiosz.get("backstage/sysDict/isShow/LOAN_RATE").then(r => {
        //审核结果
        if (r.code == 200) {
          this.statusList = r.data;
        }
      });
    }
  },
  created() {
    this.getDic();
    if (this.$route.query.id) {
      this.sendInfoOne.myDeptId = this.$route.query.id;
      this.getData();
    }
  },
  mounted(){
    const that = this
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  }
};
</script>

<style lang="scss" scoped>
.super_boxs{
 height:calc(100% - 90px);
  overflow-x: hidden;
  overflow-y: auto;
}
.warp {
  height:calc(100% - 20px);
  padding:10px 20px;
  .detailBas {
    margin-top: 20px;
  }
}
.box{
    // margin-top: 20px;
    &_card{
      border:none;
      .el-row{
        margin-top:10px;
        .child{
          margin-top:10px;
        }
      }
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
    .childMulti{
      margin-top:0 !important;
    }
    .child{
      margin-bottom:10px;
    }
    .attachment{
      margin-top:10px;
    }
    .basisTitle{
      margin-bottom:10px;
    }
}
.boxChild{
  .child,.basisTitle{
      margin-bottom:10px;
    }
}
</style>